export class EntiteChamp {
  nom: string
  type: string
  modificateur: number
  label: any
}